import {
  AADHAAR_PATTERN,
  GST_PATTERN,
  PAN_PATTERN,
  detectKycFieldKind,
} from '@/features/team/utils/kycInputMask';
import type { NormalizedField } from '@/features/auth/types/onboardingFields';

/** Validate a dynamic selected field value; returns error message or null. */
export function validateSelectedField(
  field: NormalizedField,
  value: string,
): string | null {
  const trimmed = String(value ?? '').trim();
  const label = field.fieldLabel || field.fieldName;

  if (field.isRequired && !trimmed) {
    return `${label} is required`;
  }
  if (!trimmed) return null;

  const kind = detectKycFieldKind(
    field.fieldName,
    field.fieldType,
    field.fieldLabel,
  );
  if (kind === 'pan' && !PAN_PATTERN.test(trimmed)) {
    return `Invalid ${label} format`;
  }
  if (kind === 'gst' && !GST_PATTERN.test(trimmed)) {
    return `Invalid ${label} format`;
  }
  if (kind === 'aadhaar' && !AADHAAR_PATTERN.test(trimmed)) {
    return `Invalid ${label} format`;
  }

  const validation = field.validation;
  if (!validation) return null;

  const min = validation.minLength ?? validation.min;
  const max = validation.maxLength ?? validation.max;
  if (min != null && trimmed.length < Number(min)) {
    return `${label} must be at least ${min} characters`;
  }
  if (max != null && trimmed.length > Number(max)) {
    return `${label} must be at most ${max} characters`;
  }
  if (validation.pattern) {
    try {
      if (!new RegExp(validation.pattern).test(trimmed)) {
        return `Invalid ${label} format`;
      }
    } catch {
      /* ignore bad pattern from API */
    }
  }

  return null;
}
